import type { CountryConfig } from './types';

export const arCountry: CountryConfig = {
  code: 'AR',
  name: 'Argentina',
  flag: '🇦🇷',
  currency: { primary: 'ARS', secondary: 'USD' },
  features: new Set(['retenciones', 'factura_abc', 'sircreb']),
  ivaRates: [21, 10.5],
  ivaRateDefault: 21,
};
